export function intToHex(value: number): string {
    return Math.max(0, Math.min(255, value)) // clamp
        .toString(16)
        .padStart(2, '0');
}

export function rgbToHex(r: number, g: number, b: number): string {
    return `#${intToHex(r)}${intToHex(g)}${intToHex(b)}`;
}

export function rgbaToHex(r: number, g: number, b: number, a: number): string {
    return `#${intToHex(r)}${intToHex(g)}${intToHex(b)}${intToHex(a)}`;
}

export function hexToRgb(value: string): number[] {
    const rgb = [];
    for (let i = 1; i <value.length; i+=2) {
        rgb.push(parseInt(value.substring(i,i + 2), 16))
    }

    return rgb;
}
